import SyncIcon from '@mui/icons-material/Sync';
import { Box, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import { UserRoleDto } from '@/api/generated';
import { useUserContext } from '@/context/userContext/User.context.ts';
import { cvSearchSyncStatusStyles as styles } from '@/layouts/private/topBar/components/cvSearchSyncStatus/CvSearchSyncStatus.styles.ts';
import { CvSearchSyncStatusDrawer } from '@/layouts/private/topBar/components/cvSearchSyncStatus/CvSearchSyncStatusDrawer.comp.tsx';
import { cvSearchSyncStatusUtil } from '@/layouts/private/topBar/components/cvSearchSyncStatus/utils/cvSearchSyncStatus.util.ts';
import { useGetCvSearchSyncStatus } from '@/layouts/private/topBar/components/cvSearchSyncStatus/utils/useGetCvSearchSyncStatus.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const CvSearchSyncStatus: React.FC = () => {
  const { t } = useTranslationWithPrefix('layouts.cvSearchSyncStatus');
  const { role } = useUserContext();
  const isAdmin = role === UserRoleDto.Admin;
  const { syncStatus } = useGetCvSearchSyncStatus(isAdmin);
  const [open, setOpen] = useState(false);

  if (!isAdmin) {
    return null;
  }

  const tooltip = cvSearchSyncStatusUtil.tooltip(syncStatus);

  return (
    <>
      <Tooltip title={t(tooltip.key, tooltip.params)}>
        <IconButton aria-label={t('button')} onClick={() => setOpen(true)}>
          <SyncIcon />
          <Box
            data-testid="cv-search-sync-status-dot"
            sx={styles.dot(cvSearchSyncStatusUtil.dotColor(syncStatus?.health))}
          />
        </IconButton>
      </Tooltip>
      <CvSearchSyncStatusDrawer
        onClose={() => setOpen(false)}
        open={open}
        syncStatus={syncStatus}
      />
    </>
  );
};
